__turbopack_context__.v({
  "container": "PrizeCard2026-module__3qRsZq__container",
  "favouriteButtonContainer": "PrizeCard2026-module__3qRsZq__favouriteButtonContainer",
  "favouriteButtonContainerAsSquare": "PrizeCard2026-module__3qRsZq__favouriteButtonContainerAsSquare",
  "favouriteButtonContainerAsWide": "PrizeCard2026-module__3qRsZq__favouriteButtonContainerAsWide",
  "fullSizeLink": "PrizeCard2026-module__3qRsZq__fullSizeLink",
  "heading": "PrizeCard2026-module__3qRsZq__heading",
  "imageContainer": "PrizeCard2026-module__3qRsZq__imageContainer",
  "lockedBanner": "PrizeCard2026-module__3qRsZq__lockedBanner",
  "lockedText": "PrizeCard2026-module__3qRsZq__lockedText",
  "prizeTierBadgeContainer": "PrizeCard2026-module__3qRsZq__prizeTierBadgeContainer",
  "subheading": "PrizeCard2026-module__3qRsZq__subheading",
  "textContainer": "PrizeCard2026-module__3qRsZq__textContainer",
});
